module.exports = __webpack_public_path__ + "img/coupon_tutorial_ROMAPI01.0db52c16.jpg";